import {getheaders} from "./authService";

export async function getAllProperties(startDate, endDate) {

    let requestOptions = {
        method: 'GET', headers: getheaders(), redirect: 'follow'
    };
    return fetch("/goapi/properties", requestOptions)
}

export async function getPropertyById(propertyId) {
    let requestOptions = {
        method: 'GET', headers: getheaders(), redirect: 'follow'
    };
    return fetch(`/goapi/properties/${propertyId}`, requestOptions)
}

export async function createOrUpdatePropertyInstruction(payload, type) {
    let httpMethod = "POST";
    if (payload.id) {
        httpMethod = "PUT";
    }
    let requestOptions = {
        method: httpMethod, headers: getheaders(), redirect: 'follow', body: JSON.stringify(payload)
    };
    return fetch("/api/instructions/" + type, requestOptions)
}

export async function getPropertyInstruction(propertyId, type) {
    let requestOptions = {
        method: 'GET', headers: getheaders(), redirect: 'follow'
    };
    return fetch("/api/instructions/" + type + "/" + propertyId, requestOptions)
}

export async function getPropertyIssue(propertyId) {
    let requestOptions = {
        method: 'GET', headers: getheaders(), redirect: 'follow'
    };
    return fetch("/api/issues/" + propertyId, requestOptions)
}

export async function createOrUpdatePropertyIssue(payload) {
    let httpMethod = "POST";
    if (payload.id) {
        httpMethod = "PUT";
    }
    let requestOptions = {
        method: httpMethod, headers: getheaders(), redirect: 'follow', body: JSON.stringify(payload)
    };
    return fetch("/api/issues", requestOptions)
}

export async function deletePropertyIssue(issueId) {
    let requestOptions = {
        method: 'DELETE', headers: getheaders(), redirect: 'follow'
    };
    return fetch("/api/issues/" + issueId, requestOptions)
}

export async function resolveOrReopenIssue(payload) {
    let httpMethod = "PUT";
    let action = payload.action;

    console.log(action + " issue" + payload.cos_job_id)
    let requestOptions = {
        method: httpMethod, headers: getheaders(), redirect: 'follow', body: JSON.stringify(payload)
    };
    return fetch(`/api/issues/${action}`, requestOptions)
}
